import fornecedoresMenu from './fornecedores/menu'
import gestoresMenu from './gestores/menu'
import gerentesMenu from './gerentes/menu'
import uabsMenu from './uabs/menu'
import apoiosMenu from './apoios/menu'

export default {
    name: 'SGF',
    url: '/credenciados',
    icon: 'fa fa-users',
    regras: [
        ...fornecedoresMenu.map(r => r.regras),
        ...gestoresMenu.map(r => r.regras),
        ...gerentesMenu.map(r => r.regras),
        ...uabsMenu.map(r => r.regras),
        ...apoiosMenu.map(r => r.regras)
    ],
    children: [
        ...fornecedoresMenu,
        ...gestoresMenu,
        ...gerentesMenu,
        ...uabsMenu,
        ...apoiosMenu
    ]
}
